<template>
  <div class="page-banner">
    <div class="page-banner__overlay"></div>
    <div class="page-banner__content">
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBanner',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.page-banner {
  position: relative;
  margin-top: 6.5rem; /* Matches top-bar + site-nav height on desktop */
  padding: 4.5rem 1.5rem;
  background: linear-gradient(135deg, var(--color-dark) 0%, var(--color-primary-dark) 100%);
  text-align: center;
  overflow: hidden;
  border-bottom: 3px solid var(--color-primary);

  &__overlay {
    position: absolute;
    inset: 0;
    background: url('~@/assets/photos/hero-1.jpg') center/cover no-repeat;
    opacity: 0.12;
    transform: scale(1.05);
  }

  &__content {
    position: relative;
    z-index: 1;

    h1 {
      color: #fff;
      font-size: 2.25rem;
      font-weight: 800;
      margin-bottom: 0.5rem;
      letter-spacing: 0.05em;
      text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    p {
      color: rgba(255, 255, 255, 0.9);
      font-size: 1.05rem;
      font-weight: 500;
      margin: 0;
      letter-spacing: 0.02em;
    }
  }
}

@media (max-width: 992px) {
  .page-banner {
    margin-top: 4rem; /* Only site-nav is visible on tablet/mobile */
    padding: 3rem 1.5rem;

    h1 {
      font-size: 1.75rem;
    }

    p {
      font-size: 0.95rem;
    }
  }
}
</style>
